<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl" >
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;">
            <div class="row">
                <div class="col-12 col-md-5 mb-3">
                    <label>Категория </label>
                    <select class="form-control" v-model="category" >
                        <option value=""></option>
                        <option :value="option.id" v-for="option in categories" :key="option.id">
                            {{option.name}}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-5 mb-3">
                    <label>Излаш </label>
                    <input type="text" class="form-control" v-model="search"/>
                </div>
                <div class="col-12 col-md-2 align-self-end">
                    <button class="all-btn m-0 mb-3" @click="searchInit()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
                <div class="col-12 table-responsive">
                    <div class="card">
                        <div class="table-wrapper">
                          <table class="table">
                              <thead>
                              <tr>
                                  <th class="text-center">#</th>
                                  <th style="width: 200px" class="text-center">Машина расми</th>
                                  <th class="text-center">Номи</th>
                                  <th style="width: 200px" class="text-center">Нархи</th>
                                  <th class="text-center">Категория</th>
                                  <th class="text-center">Ўлчов бирлиги</th>
                              </tr>
                              </thead>
                              <tbody v-if="!loading && results">
                              <tr v-for="(result, index) in results.data" :key="result.id">
                                  <td class="text-center">{{index + 1}}</td>
                                  <td class="text-center">
                                      <img :src="result.photo ? result.photo.url : ''" width="200" height="200" @click="showPhotos(result.id,index)"/>
                                  </td>
                                  <td class="text-center">
                                      {{result.name}}
                                  </td>
                                  <td class="text-center">
                                      {{result.price | currency('', 0, { thousandsSeparator: ' ' })}}
                                  </td>
                                  <td class="text-center">
                                      {{result.category}}
                                  </td>
                                  <td class="text-center" style="display: table-cell">
                                      {{result.um}}
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
        <FitmentPhotosView/>
    </b-modal>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import FitmentPhotosView from '@/views/fitment/FitmentPhotosView';
    export default {
        name: "FitmentApiData",
        components: {
            'b-pagination': bPagination,
            'b-modal': bModal,
            FitmentPhotosView: FitmentPhotosView
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                loading: false,
                results: null,
                filter: {"page": {page: 1, size: 100},roles: []},
                categories: [],
                category:'',
                search:'',
                fitment: null
            }
        },
        methods: {
            init() {
                this.loading = true;
                if (this.categories.length === 0) {
                    this.$http.post('fitment/olinguz/api/categories', this.filter)
                        .then(res => {
                            this.categories = res.data;
                        }, () => {
                            this.$swal({
                                title: 'Хато',
                                text: 'oling.uz га уланиб бўлмади!',
                                type: 'error'
                            });
                        });
                }

                if (this.category !== '') {
                    this.filter.roles[0] = this.category;
                } else {
                    this.filter.roles = [];
                }

                if (this.search !== '') {
                    this.filter.search = this.search;
                } else {
                    this.filter.search = '';
                }

                this.$http.post('fitment/olinguz/api/products',  this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, () => {
                        this.$swal({
                            title: 'Хато',
                            text: 'oling.uz га уланиб бўлмади!',
                            type: 'error'
                        });
                    });
            },
            cancel() {
                this.show = false;
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.init();
            },
            showPhotos(id,index) {
                this.fitment = this.results.data[index];
                this.$eventBus.$emit('FitmentPhotosView', this.fitment);
            },
            searchInit() {
                this.init();
            }
        },
        created() {
            this.$eventBus.$on('FitmentApiData', (data) => {
                if (data) {
                    this.init();
                    this.show = true;
                } else {
                    this.show = false;
                    this.fitment.apiData = true;
                    this.$eventBus.$emit('FitmentItemEdit', this.fitment);
                }
            });
        }
    }
</script>

<style scoped>

</style>